import {
    useState,
    useCallback,
    useEffect,
} from 'react';

import { webLibSdk } from 'helpers';
import { CUSTOM_ALLOCATION_TYPE } from '_constants/allocationTypes';
import toastAlert from 'components/UI/Alert';
import StyledTabs from './styles';
import AllocatedAddresses from './AllocatedAddresses';
import History from './History';
import SetAllocation from './SetAllocation/CustomSetAllocation';
import Filtering from './Filtering';
import Tabs from './Tabs';

const CustomAllocationType = ({ currentAddress }) => {
    const [tab, setTab] = useState('allocatedAddresses');
    const [filterDate, setFilterDate] = useState(null);
    const [addressSearch, setAddressSearch] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [distributionProperties, setDistributionProperties] = useState(null);

    useEffect(() => {
        const getAccess = async () => {
            try {
                setIsAdmin(await webLibSdk.hasRole(currentAddress, 'Admin'));
                setDistributionProperties(await webLibSdk.customDistributionProperties());
            } catch (err) {
                toastAlert({
                    type: 'error',
                    customMessage: err,
                });
                console.error('CustomAllocationType err: ', err);
            }
        };

        getAccess();
    }, [currentAddress]);

    const updateTab = useCallback((val) => {
        setTab(val);
        setFilterDate(null);
        setAddressSearch('');
    }, []);

    return (
        <StyledTabs className="container">
            { process.env.REACT_APP_OPEN_TABLE_DATA === 'TRUE' || (isAdmin && distributionProperties)
                ? (
                    <>
                        {!!(isAdmin && distributionProperties) && <SetAllocation distributionProperties={distributionProperties} />}
                        <Tabs
                            tab={tab}
                            updateTab={updateTab}
                        />
                        <Filtering
                            filterDate={filterDate}
                            setFilterDate={setFilterDate}
                            addressSearch={addressSearch}
                            setAddressSearch={setAddressSearch}
                        />
                        <div>
                            <AllocatedAddresses
                                isShown={tab === 'allocatedAddresses'}
                                types={{ type: isAdmin ? 'Admin' : '' }}
                                filterDate={filterDate}
                                addressSearch={addressSearch}
                                distributionAllocationType={CUSTOM_ALLOCATION_TYPE}
                            />
                            <History
                                isShown={tab === 'history'}
                                filterDate={filterDate}
                                addressSearch={addressSearch}
                                distributionAllocationType={CUSTOM_ALLOCATION_TYPE}
                            />
                        </div>
                    </>
                )
                : null}
        </StyledTabs>
    );
};

export default CustomAllocationType;
